import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LeaveService } from 'src/app/rest_services/msLeaveServices/leave.service';

@Component({
  selector: 'app-absence-request',
  templateUrl: './absence-request.component.html',
  styleUrls: ['./absence-request.component.css']
})
export class AbsenceRequestComponent implements OnInit {
  addedMsg: any;
  addError: any;
  sendRequestloading: any;
  absenceForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private leaveService : LeaveService,
    private location : Location,
    private router :Router
    ) {}

  ngOnInit(): void {
    // Get the current date
    const currentDate = new Date();

    // Format the date as 'YYYY-MM-DD' (assuming your form expects this format)
    const formattedDate = this.formatDate(currentDate);

    // Initialize the form with the current date for startDate and endDate
    this.absenceForm = this.fb.group({
      type: ['', Validators.required],
      motif: [''],
      startDate: [formattedDate,  [Validators.required, this.startDateValidator]],
      endDate: [formattedDate,  [Validators.required, this.endDateValidator]],
    });

    var glob = this;
    $('body').on('click', ".upload__img-close", function (e:any) {
      var file = $(this).parent().data("file");
      for (var i = 0; i < glob.imgArray.length; i++) {
        if (glob.imgArray[i].name === file) {
          glob.imgArray.splice(i, 1);
          glob.picturesVisit.splice(i, 1);
          break;
        }
      }
      $(this).parent().parent().remove();
    });
  }
  startDateValidator(control: any) {
    const startDate = new Date(control.value);
    const today = new Date();

    // Extract year, month, and day from the dates
    const startDateYear = startDate.getFullYear();
    const startDateMonth = startDate.getMonth();
    const startDateDay = startDate.getDate();

    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth();
    const todayDay = today.getDate();

    // Compare year, month, and day
    if (startDateYear > todayYear ||
        (startDateYear === todayYear && startDateMonth > todayMonth) ||
        (startDateYear === todayYear && startDateMonth === todayMonth && startDateDay >= todayDay)) {
        return null; // Start date is today or later
    } else {
        return { invalidStartDate: true }; // Start date is before today
    }
  }

  endDateValidator(control: any) {
    const endDate = new Date(control.value);
    const startDate = new Date(control.parent?.get('startDate').value);

    // Compare endDate with startDate
    if (endDate >= startDate) {
        return null; // End date is valid
    } else {
        return { invalidEndDate: true }; // End date is before the start date
    }
}

  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];

  addPic(event :any) {
    const imgWrap = document.querySelector('.upload__img-wrap');
    const files = event.target.files;
    const glob =this;
  
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file.type.match('image.*')) continue;
        this.imgArray.push(file);
  
      const reader = new FileReader();
      reader.onload = function(e) {
        var imgBox = "<div class='upload__img-box'><div style='background-image: url(" + e.target?.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + file.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";

        if (imgWrap) {
          imgWrap.innerHTML += imgBox;
          if (glob.picturesVisit == undefined || glob.picturesVisit == null) {
            glob.picturesVisit =[]
          }
          glob.picturesVisit?.push(e.target?.result);
        }
      };
  
      reader.readAsDataURL(file);
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
  saveAbsence() {
    if (this.absenceForm.valid) {
      $("html, body").animate({scrollTop:0})
      this.sendRequestloading = true;
      var reqBody = this.absenceForm.value;
      reqBody = {
        type_leave: this.absenceForm.get('type')?.value,
        start_leave: this.absenceForm.get('startDate')?.value,
        finish_leave: this.absenceForm.get('endDate')?.value,
        reason_leave: this.absenceForm.get('motif')?.value,
        pj_leave : this.picturesVisit
      }
      this.leaveService.createLeave(reqBody);
      this.leaveService.createLeaveSubject.subscribe(
        (data : any)=>{
          this.sendRequestloading = false;
          if(data.status =='200'){
            (<any>$("#profil_added")).show();
            // this.absenceForm.reset();
            this.picturesVisit=[];
            const imgWrap = document.querySelector('.upload__img-wrap');
            if(imgWrap) imgWrap.innerHTML = "";
            setTimeout(() => {
              (<any>$("#profil_added")).hide();
              // this.location.back();
              this.router.navigate(['/absence-detail/' + data.leaveId]);
            }, 3000);
          }
        },
        (error) => {
            this.sendRequestloading = false;
            (<any>$("#profil_not_added")).show();
            setTimeout(() => {
              (<any>$("#profil_not_added")).hide();
            }, 3000);
        }
      )
    } else {
      this.absenceForm.markAllAsTouched();
      this.sendRequestloading = false;
    }
  }
}
